import { createContext, useContext, useState } from 'react';
import { theme } from '../theme';
import { useMediaQuery } from '@mui/material';
import { useLocation } from 'react-router-dom';

const LayoutContext = createContext();

export const LayoutProvider = ({ children }) => {
    const location = useLocation();
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const drawerWidth = isMobile ? 240 : (isCollapsed ? 70 : 270);

    const toggleCollapse = () => {
        if (!isMobile) {
            setIsCollapsed(!isCollapsed);
        }
    };

    const toggleMobileMenu = () => setMobileOpen(!mobileOpen);


    return (
        <LayoutContext.Provider value={{
            isCollapsed,
            mobileOpen,
            toggleCollapse,
            toggleMobileMenu,
            drawerWidth: 0,
            isMobile,
            pathname: location?.pathname
        }}>
            {children}
        </LayoutContext.Provider>
    );
};

export const useLayout = () => useContext(LayoutContext);